<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>

    <div class="container">
      <div class="content" v-for="item in articleData" :key="item.index">
        <h2>{{ item.title }}</h2>
        <p>
          <span>发布时间：{{ item.createTime  | dataFormat('yyyy-mm-dd')}}</span>
          <span style="text-align: right">阅读量：{{ item.pv + item.setpv }}</span>
        </p>
        <div class="contentHtml" style="text-align: justify" v-html="item.content">

        </div>
      </div>
    </div>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";

export default {
  name: "ArticleContentYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM
  },
  data(){
    return{
      restfulUrl:'articles',
      articleTitle:'',
      articleData: [],
    }
  },
  methods:{
    getOneByID:function(uid){
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){

          this.articleData.push(res.data)
          this.articleTitle = res.data.title
        }
      },err=>{
        console.log(err)
      })
    },
    //增加阅读量
    addPv:function(){
      request({
        method:'POST',
        url:this.restfulUrl+'/pv',
        data:{id:this.$route.params.id}
      }).then(res =>{
        if(res.code==1){
          return
        }
      },err=>{
        console.log(err)
      })
    }
  },
  mounted() {
    this.getOneByID(this.$route.params.id);
    this.addPv();
  },
  filters:{
    dataFormat(input,pattern=''){
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');

      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');

        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;

      }

    }
  },
  metaInfo() {
    return {
      title: this.articleTitle || 'My Vue App'
    };
  }
}
</script>

<style scoped>
.container{
  padding:0 15px;
}
.content{
  margin: 20px auto 0;
}
.content h2{

  margin: 0 auto;
  padding:20px 0 10px;
}
.content p{
  text-align: left;
  display: flex;
  padding:10px 0;
  border-bottom: 1px solid silver;

}
.content p span{
  flex: 1;
  font-size: 14px;
  color:silver;
}
.content div{
  padding:20px 0;
  min-height: 600px;
}
</style>
